"use strict";

const IncidentsGeoServerPopup = function () {
  var getPopupHtml = function (data) {
    const popupColor = IncidentsIcon.getIconColor(data.incidentStatus);
    const showNewInvestigationButton = data.incidentStatus === "new";
    const isFieldPersonnel = Session.isFieldPersonnel();
    const canIssueEnforcement = UserPermissions.getPermission("can_issue_incident_enforcement");

    const requestingTypeName = IncidentInventoryConstants.getRequestingTypeOptions().getObjectWith(
      "value",
      data.requestingType,
    )?.name;
    const requestingAffiliationName =
      IncidentInventoryConstants.getRequestingAffiliationOptions().getObjectWith(
        "value",
        data.requestingAffiliation,
      )?.name;

    return nunjucks.render("popups/incidentsPopup.njk", {
      data,
      popupColor,
      showNewInvestigationButton,
      requestingTypeName,
      requestingAffiliationName,
      incidentType: Misc.getOptionNameByValue(
        IncidentInvestigationConstants.getIncidentTypeOptions(),
        data.lastInvestigation?.incidentType,
      ),
      enforcementLevel: Misc.getOptionNameByValue(
        IncidentInvestigationConstants.getEnforcementLevelOptions(),
        data.lastInvestigation?.enforcementLevel,
      ),
      illicitActivity: Misc.getOptionNameByValue(
        IncidentInvestigationConstants.getIllicitActivityOptions(),
        data.illicitActivity,
      ),
      isFieldPersonnel,
      canIssueEnforcement,
    });
  };

  var onPopupOpenWithData = function (data, $element, invalidateLayerDataFunction) {
    var onPopupDelete = function () {
      deleteIncident(data.id, data.incidentName, invalidateLayerDataFunction);
    };

    $element.off("click", ".popup-delete-button", onPopupDelete);
    $element.on("click", ".popup-delete-button", onPopupDelete);

    $element
      .off("click", ".js-issue-incident-enforcement")
      .on("click", ".js-issue-incident-enforcement", function () {
        const id = $(this).data("id");
        IncidentEnforcementController.loadNewEnforcement(id);
      });

    IncidentHistory.renderIncidentHistory(data.history);
  };

  var deleteIncident = function (id, name, invalidateLayerDataFunction) {
    MessageModal.showConfirmWarningModal(
      `Delete incident ${name}? Click "Delete" to permanently delete the incident and all associated investigations, photos and files. Click "Cancel" to return.`,
      async function () {
        await ApiCalls.deleteIncident(id);
        invalidateLayerDataFunction();
        closePopup();
      },
      "Cancel",
      "Delete",
    );
  };

  var closePopup = function () {
    const closeButton = $(".leaflet-popup-close-button");
    if (closeButton.length > 0) {
      closeButton[0].click();
    }
  };

  var onPopupOpen = async function (properties) {
    const id = properties.id;
    const data = await ApiCalls.getIncidentPopup(id);
    const html = getPopupHtml(data);
    const $popup = $(".leaflet-popup-content");
    $popup.html(html);
    const layerModule = LayerFunctions.getLayerModule("incidents");
    onPopupOpenWithData(data, $popup, layerModule.invalidateLayerData);
  };

  return {
    getPopupHtml,
    onPopupOpen,
  };
};

module.exports = IncidentsGeoServerPopup();

const ApiCalls = require("../../apiCalls");
const IncidentHistory = require("./incidentHistory");
const IncidentInventoryConstants = require("./incidentInventoryConstants");
const IncidentInvestigationConstants = require("../incidentInvestigation/incidentInvestigationConstants");
const IncidentsIcon = require("./incidentsIcon");
const IncidentEnforcementController = require("../incidentEnforcement/incidentEnforcementController");
const LayerFunctions = require("../../layerFunctions");
const MessageModal = require("../../modals/messageModal");
const Misc = require("../../misc");
const Session = require("../../login/session");
const UserPermissions = require("../../login/userPermissions");
